var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSofa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 24,
    rx: 4,
    fill: "#FDF3E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9259 16.25V19.0625M7.23975 16.25V19.0625V16.25Z",
    stroke: "#F6931E",
    strokeWidth: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30747 10.625L6.31253 6.59292C6.31299 6.23081 6.60215 5.9375 6.95869 5.9375H24.7631C25.12 5.9375 25.4093 6.23131 25.4093 6.59375V10.625M6.30747 10.625H25.4093M6.30747 10.625H5.38439C5.12949 10.625 4.92285 10.8349 4.92285 11.0938V16.25H26.7075L26.6227 11.0859C26.6185 10.8301 26.4132 10.625 26.1613 10.625H25.4093M6.30747 10.625H7.69208M25.4093 10.625H24.3075M7.69208 10.625V13.4375H11.8459H15.9998M7.69208 10.625H15.9998M24.3075 10.625V13.4375H15.9998M24.3075 10.625H15.9998M15.9998 13.4375V10.625",
    stroke: "#F6931E",
    strokeWidth: 1.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSofa);
export default __webpack_public_path__ + "static/media/sofa.8753a0d0e543dfa377560e6cbcb68d0f.svg";
export { ForwardRef as ReactComponent };